import { Checkbox } from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React from 'react';

const SelectOneContainer = ({ addItem, removeItem, row, selectedItemsIds }) => {
  const { itemId } = row.values.checkbox;
  const [isChecked, setIsChecked] = React.useState(
    selectedItemsIds.includes(itemId)
  );

  const toggleSelectOne = () => {
    if (isChecked) {
      removeItem(itemId);
    } else {
      addItem(itemId);
    }

    setIsChecked(!isChecked);
  };

  return (
    <Checkbox
      data-testid={`table-column-checkbox-${itemId}`}
      checked={isChecked}
      onChange={toggleSelectOne}
    />
  );
};

SelectOneContainer.propTypes = {
  itemId: PropTypes.number,
  row: PropTypes.object.isRequired,
  addItem: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  selectedItemsIds: PropTypes.array.isRequired,
};

export default SelectOneContainer;
